export default __webpack_public_path__ + "static/media/Points_being_collected_pld.9d57da6c.gif";